import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducer from "./requirements.reducer";
var PERSIST_CONFIG = {
    key: "requirements",
    storage: storage,
    whitelist: ["requirements"],
};
// eslint-disable-next-line import/no-default-export
export default persistReducer(PERSIST_CONFIG, reducer);
